type HealthCounts = {
  needsApproval: number;
  missingMedia: number;
  readyToPublish: number;
  scheduledThisWeek: number;
  autopilot: boolean;
};

type PipelineHealthCardProps = {
  healthCounts: HealthCounts;
};

export function PipelineHealthCard({ healthCounts }: PipelineHealthCardProps) {
  return (
    <div className="cp-health-strip">
      <div
        className={`cp-health-card${healthCounts.needsApproval > 0 ? ' cp-health-card--alert' : ''}`}
      >
        <div
          className={`cp-health-card__count${healthCounts.needsApproval === 0 ? ' cp-health-card__count--zero' : ' cp-health-card__count--alert'}`}
        >
          {healthCounts.needsApproval}
        </div>
        <div className="cp-health-card__label">Needs Approval</div>
      </div>

      <div className="cp-health-card">
        <div
          className={`cp-health-card__count${healthCounts.missingMedia === 0 ? ' cp-health-card__count--zero' : ''}`}
        >
          {healthCounts.missingMedia}
        </div>
        <div className="cp-health-card__label">Missing Media</div>
      </div>

      <div className="cp-health-card">
        <div
          className={`cp-health-card__count${healthCounts.readyToPublish === 0 ? ' cp-health-card__count--zero' : ''}`}
        >
          {healthCounts.readyToPublish}
        </div>
        <div className="cp-health-card__label">Ready to Publish</div>
      </div>

      <div className="cp-health-card">
        <div
          className={`cp-health-card__count${healthCounts.scheduledThisWeek === 0 ? ' cp-health-card__count--zero' : ''}`}
        >
          {healthCounts.scheduledThisWeek}
        </div>
        <div className="cp-health-card__label">Scheduled</div>
      </div>

      <div className="cp-health-card">
        <div className="cp-health-card__count cp-health-card__count--zero">
          {healthCounts.autopilot ? '⚡' : '—'}
        </div>
        <div className="cp-health-card__label">Autopilot</div>
        <span
          className={`cp-health-card__badge cp-health-card__badge--${healthCounts.autopilot ? 'on' : 'off'}`}
        >
          {healthCounts.autopilot ? 'ON' : 'OFF'}
        </span>
      </div>
    </div>
  );
}
